import React from 'react';
import { CalendarTodayOutlined, ChevronRightRounded } from '@mui/icons-material';
import { PillButton, Stack, Text } from 'library/ui';

export function ScheduleACall() {
    return (
        <Stack padding="none" align="center" gap="sm">
            <Text weight="bold">Have questions?</Text>
            <PillButton
                variant="secondary"
                icon={<CalendarTodayOutlined sx={{ fontSize: 18 }} />}
                onClick={() => window.open('https://meetings.hubspot.com/joy-gupit', '_blank', 'noreferrer')}
            >
                Schedule a call with Tandem
                <ChevronRightRounded sx={{ fontSize: 18 }} />
            </PillButton>
        </Stack>
    );
}
